import { getFieldTypeInfo } from "@/pages/digital-files/utils";
import { useEntity } from "../context";
import FieldCard from "./FieldCard";

export const SectionListView = () => {
  const { sections, selectFieldForSummary, unselectFieldFromSummary } =
    useEntity();

  const handleToggleShowInSummary = (data: {
    sectionId: string;
    fieldId: string;
    value: boolean;
  }) => {
    const { value, sectionId, fieldId } = data;
    if (value) {
      selectFieldForSummary(sectionId, fieldId);
    } else {
      unselectFieldFromSummary(sectionId, fieldId);
    }
  };

  // Mostrar todas las secciones excepto la última
  const visibleSections = sections.filter((s) => s.fields.length > 0);

  return (
    <div>
      {visibleSections.length === 0 && (
        <p className="text-on-disabled leading-3xl text-size-body">
          Agrega secciones y campos para configurar la entidad
        </p>
      )}
      {visibleSections.length > 0 &&
        visibleSections.map((section) => (
          <div
            key={section.id}
            className="border-b border-neutral-quiet py-4 first:pt-0 flex flex-col gap-4"
          >
            <p className="text-body-loud text-size-body leading-3xl font-semibold">
              {section.title}
            </p>

            {section.fields &&
              section.fields.length > 0 &&
              section.fields.map((field) => {
                const fieldInfo = getFieldTypeInfo(field);
                return (
                  <FieldCard
                    key={field.id}
                    field={field}
                    fieldInfo={fieldInfo}
                    sectionId={section.id}
                    readonly
                    onToggleShowInSummary={handleToggleShowInSummary}
                  />
                );
              })}
          </div>
        ))}
    </div>
  );
};
